// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2WCqy","errorLogs":"styles_errorLogs__DhBGH"};